/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Kind of relationship between two partners.   (bipro-datentypen::Partnerbeziehung)     * `Spouse`        - german: Ehepartner   * `LifePartner`   - german: Lebenspartner   * `Child`         - german: Kind   * `Parent`        - german: Elternteil   * `GrandChild`    - german: Enkelkind   * `GrandParent`   - german: Großelternteil   * `Sibling`       - german: Geschwisterteil
 */
export const PartnerRelationshipKind = {
  Spouse: 'Spouse',
  LifePartner: 'LifePartner',
  Child: 'Child',
  Parent: 'Parent',
  GrandChild: 'GrandChild',
  GrandParent: 'GrandParent',
  Sibling: 'Sibling',
} as const;
export type PartnerRelationshipKind = (typeof PartnerRelationshipKind)[keyof typeof PartnerRelationshipKind];
